export const DEPOSIT_BANKS = [
  { code: 'Woori', label: '우리은행', onboardingAvailable: true, authType: 'code' },
  { code: 'KB', label: 'KB국민은행', onboardingAvailable: true, authType: 'instant' },
  { code: 'Shinhan', label: '신한은행', onboardingAvailable: true, authType: 'code' },
  { code: 'Hana', label: '하나은행', onboardingAvailable: true, authType: 'instant' },
  { code: 'Nonghyup', label: 'NH농협은행', onboardingAvailable: true, authType: 'code' },
  { code: 'IBK', label: 'IBK기업은행', onboardingAvailable: true, authType: 'code' },
] as const;

export type DepositBankCode = typeof DEPOSIT_BANKS[number]['code'];

export function getDepositBank(code: DepositBankCode) {
  return DEPOSIT_BANKS.find((bank) => bank.code === code);
}
